// Subscription-related types

// Active subscription statuses
// Possible values are incomplete, incomplete_expired, trialing, active, past_due, canceled, unpaid, or paused.
const ACTIVE_SUBSCRIPTION_STATUSES = ['pending_new', 'trialing', 'active', 'past_due', 'unknown']

export interface SubscriptionInformation {
  subscriptions: OrganizationSubscription[]
  subscriptionTiers: SubscriptionTier[]
}

// SubscriptionTier represents a subscription tier/plan
export interface SubscriptionTier {
  id: string
  label: string
  stripeProductId: string
  name: string
  maxUsers: number
  features: string[]
  limits: string[]
  createdAt?: string
  updatedAt?: string
}

// OrganizationSubscription represents a customer's active subscription
export interface OrganizationSubscription {
  id: string
  organizationId: string
  stripeSubscriptionId: string
  tierId: string
  status: string
  currentPeriodEnd: string | null
  createdAt?: string
  updatedAt?: string
}

// Subscription status constants
export enum SubscriptionStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  CANCELED = 'canceled',
  PAST_DUE = 'past_due',
  TRIALING = 'trialing',
  UNPAID = 'unpaid',
}

export function activeSubscriptionCheck(subInfo: SubscriptionInformation): boolean {
  if (!subInfo.subscriptions || subInfo.subscriptions.length === 0) {
    return false
  }

  return subInfo.subscriptions.some((sub) => ACTIVE_SUBSCRIPTION_STATUSES.includes(sub.status))
}

export function checkSubscriptionFeature(subInfo: SubscriptionInformation, subFeature: string): boolean {
  // First we need to check for an active subscription.
  if (activeSubscriptionCheck(subInfo) === false) {
    return false
  }

  // Get the tier IDs of active subscriptions
  const activeSubscriptions = subInfo.subscriptions.filter((sub) => ACTIVE_SUBSCRIPTION_STATUSES.includes(sub.status))
  const activeTierIds = activeSubscriptions.map((sub) => sub.tierId)

  // Check if any of the active subscription's tiers have the requested feature
  for (const tier of subInfo.subscriptionTiers) {
    if (activeTierIds.includes(tier.id) && tier.features && tier.features.includes(subFeature)) {
      return true
    }
  }

  return false
}
